import { useMutation } from "@apollo/client";
import { ARCHIVE_GENERATION_TEMPLATE, GET_GENERATION_TEMPLATES } from "../gql";

interface UseArchiveGenerationTemplateResult {
  archiveTemplate: (agentId: string, userId: string) => Promise<void>;
  loading: boolean;
  error: Error | null;
}

export function useArchiveGenerationTemplate(
  organizationId: string,
): UseArchiveGenerationTemplateResult {
  const [mutate, { loading, error }] = useMutation<{
    archiveGenerationTemplate: { clientMutationId: string | null };
  }>(ARCHIVE_GENERATION_TEMPLATE, {
    refetchQueries: [
      {
        query: GET_GENERATION_TEMPLATES,
        variables: { organizationId },
      },
    ],
  });

  const archiveTemplate = async (
    agentId: string,
    userId: string,
  ): Promise<void> => {
    await mutate({
      variables: { agentId, userId },
    });
  };

  return {
    archiveTemplate,
    loading,
    error: error || null,
  };
}
